<!--
 * @Author: caiyuliu
 * @Date: 2025-12-15 09:46:13
 * @LastEditors: caiyuliu
 * @LastEditTime: 2025-12-15 10:04:22
 * @Description: 版本时间线组件
-->
<template>
  <div class="version-timeline">
    <h3 class="timeline-title">📅 版本更新时间线</h3>
    <div class="timeline-container">
      <div v-for="(version, index) in versions" :key="`${version.product}-${version.version}`" class="timeline-item">
        <div class="timeline-dot"></div>
        <div class="timeline-line" v-if="index < versions.length - 1"></div>
        <div class="timeline-content">
          <div class="version-header">
            <div class="version-info">
              <span class="version-tag">{{ getProductName(version.product) }} v{{ version.version }}</span>
              <span class="version-date">{{ version.updateDate }}</span>
            </div>
            <button class="expand-btn" @click="toggleVersion(index)">
              {{ expandedVersions.includes(index) ? '收起' : '查看详情' }}
            </button>
          </div>
          <transition name="fade">
            <div v-if="expandedVersions.includes(index)" class="version-details">
              <p class="protocol-count">包含 {{ version.protocols.length }} 个协议</p>
              <div class="protocol-list">
                <span v-for="protocol in version.protocols.slice(0, 5)" :key="protocol.name" class="protocol-tag">
                  {{ getProtocolTypeName(protocol) }}
                </span>
                <span v-if="version.protocols.length > 5" class="more-tag">+{{ version.protocols.length - 5 }} 更多</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VersionTimeline',
  props: {
    versions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      expandedVersions: []
    }
  },
  methods: {
    toggleVersion(index) {
      const idx = this.expandedVersions.indexOf(index)
      if (idx > -1) {
        this.expandedVersions.splice(idx, 1)
      } else {
        this.expandedVersions.push(index)
      }
    },
    getProductName(productId) {
      const nameMap = {
        rubikCube: '魔方',
        teachingAide: '授课助手',
        whiteBoard: '白板',
        amdoxSystem: '校园综合后台',
        eduCloud: '门户',
        android: '安卓',
        threeClass: '三个课堂',
        control: '控制软件'
      }
      return nameMap[productId] || productId
    },
    getProtocolTypeName(protocol) {
      if (protocol.path.includes('disclaimer')) return '免责声明'
      if (protocol.path.includes('privacy')) return '隐私政策'
      if (protocol.path.includes('userAgreement')) return '用户协议'
      return '协议'
    }
  }
}
</script>

<style lang="scss" scoped>
.version-timeline {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;

  .timeline-title {
    margin: 0 0 24px 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }

  .timeline-container {
    position: relative;

    .timeline-item {
      position: relative;
      padding-left: 40px;
      padding-bottom: 24px;

      &:last-child {
        padding-bottom: 0;
      }

      .timeline-dot {
        position: absolute;
        left: 0;
        top: 6px;
        width: 16px;
        height: 16px;
        background: #4caf50;
        border: 3px solid #fff;
        border-radius: 50%;
        box-shadow: 0 0 0 2px #4caf50;
        z-index: 2;
      }

      .timeline-line {
        position: absolute;
        left: 7px;
        top: 22px;
        bottom: -24px;
        width: 2px;
        background: #e0e0e0;
        z-index: 1;
      }

      .timeline-content {
        background: #f9f9f9;
        border-radius: 8px;
        padding: 16px;
        transition: all 0.3s ease;

        &:hover {
          background: #f5f5f5;
        }

        .version-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;

          .version-info {
            display: flex;
            align-items: center;
            gap: 12px;
            flex-wrap: wrap;

            .version-tag {
              font-size: 16px;
              font-weight: 600;
              color: #333;
            }

            .version-date {
              font-size: 14px;
              color: #666;
              background: #fff;
              padding: 4px 12px;
              border-radius: 12px;
            }
          }

          .expand-btn {
            padding: 6px 16px;
            background: #4caf50;
            color: #fff;
            border: none;
            border-radius: 6px;
            font-size: 13px;
            cursor: pointer;
            transition: all 0.2s ease;
            white-space: nowrap;

            &:hover {
              background: #45a049;
            }
          }
        }

        .version-details {
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #e0e0e0;

          .protocol-count {
            margin: 0 0 8px 0;
            font-size: 14px;
            color: #666;
          }

          .protocol-list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .protocol-tag {
              padding: 4px 12px;
              background: #fff;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              font-size: 13px;
              color: #666;
            }

            .more-tag {
              padding: 4px 12px;
              background: #e0e0e0;
              border-radius: 4px;
              font-size: 13px;
              color: #666;
            }
          }
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 768px) {
  .version-timeline {
    padding: 16px;

    .timeline-title {
      font-size: 18px;
    }

    .timeline-container .timeline-item {
      padding-left: 32px;

      .timeline-content {
        padding: 12px;

        .version-header {
          flex-direction: column;
          align-items: flex-start;

          .expand-btn {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
